import { useState, FormEvent } from 'react'
import { Button, Card, Flex, Heading, Text, TextField } from '@radix-ui/themes'
import { useAuth } from './AuthProvider'

const LoginPage = () => {
  const { supabaseClient } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    const { error } = await supabaseClient.auth.signInWithPassword({ email, password })

    if (error) {
      setError(error.message)
    }

    setLoading(false)
  }

  return (
    <Flex align="center" justify="center" className="h-screen">
      <Card size="4" className="w-full max-w-sm">
        <form onSubmit={handleSubmit}>
          <Flex direction="column" gap="4">
            <Heading size="5" align="center">Willie Ops</Heading>
            <Text size="2" color="gray" align="center">Internal operations</Text>

            <Flex direction="column" gap="1">
              <Text as="label" size="2" weight="medium">Email</Text>
              <TextField.Root
                type="email"
                placeholder="you@meetwillie.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Flex>

            <Flex direction="column" gap="1">
              <Text as="label" size="2" weight="medium">Password</Text>
              <TextField.Root
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Flex>

            {error && (
              <Text size="2" color="red">{error}</Text>
            )}

            <Button type="submit" size="3" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </Flex>
        </form>
      </Card>
    </Flex>
  )
}

export default LoginPage
